// extracted by mini-css-extract-plugin
export default {"Spinner":"SvgLoader_Spinner","init_loader":"SvgLoader_init_loader","rotate":"SvgLoader_rotate","Path":"SvgLoader_Path","dash":"SvgLoader_dash","Inner":"SvgLoader_Inner"};